import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import RestoreIcon from '@mui/icons-material/Restore';
import type { ControlRoomSirenSettings } from '../../constants/controlRoomSirenSettings';
import ControlRoomSirenDeviceManagement from './ControlRoomSirenDeviceManagement';

type Props = {
  value: ControlRoomSirenSettings;
  onChange: (next: ControlRoomSirenSettings) => void;
  onSave: () => void;
  onResetDefaults: () => void;
  saving?: boolean;
  cardSx?: SxProps<Theme>;
  showSnackbar?: (
    message: string,
    severity: 'success' | 'error' | 'warning' | 'info',
  ) => void;
};

const ControlRoomSirenSettingsCard: React.FC<Props> = ({
  value,
  onChange,
  onSave,
  onResetDefaults,
  saving = false,
  cardSx,
  showSnackbar,
}) => (
  <Card sx={cardSx}>
    <CardHeader
      title="관제실 경광등"
      subheader="AI 자동 감지 시 관제실 경광등·끄기 팝업. 장비는 아래 A모드(TCP 서버)로 등록."
      action={
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<RestoreIcon />}
            onClick={onResetDefaults}
            disabled={saving}
          >
            기본값
          </Button>
          <Button
            size="small"
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={onSave}
            disabled={saving}
          >
            {saving ? '저장 중…' : '정책 저장'}
          </Button>
        </Box>
      }
    />
    <CardContent>
      <FormControlLabel
        control={
          <Switch
            checked={value.include_manual_events}
            onChange={(e) =>
              onChange({ ...value, include_manual_events: e.target.checked })
            }
          />
        }
        label="수동 이벤트에도 관제실 경광등 울림"
      />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        켜면 관제사가 만든 수동 이벤트에도 관제실 경광등과 「경광등 끄기」 팝업이 뜸.
        끄면 AI 자동 감지만 대상. (장비 등록·토큰은 아래 「정책 저장」과 별개)
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        경광등 등록 (경광등/부저 A 방식)
      </Typography>
      <ControlRoomSirenDeviceManagement showSnackbar={showSnackbar} />
    </CardContent>
  </Card>
);

export default ControlRoomSirenSettingsCard;
